// A same-URL link can leave WebKit's failed module map in place. Reload the
// document explicitly so retry also retries the module and stylesheet requests.
document.querySelector<HTMLAnchorElement>(".startup a")?.addEventListener("click", (event) => {
  event.preventDefault();
  // WebKit can retain failed module responses across a document reload. The
  // manifest also includes failed requests that Resource Timing does not expose.
  async function refreshAssets() {
    const response = await fetch(`/app-assets.json?retry=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return;
    const manifest = await response.json() as Record<string, { file: string; css?: string[] }>;
    const files = Object.values(manifest).flatMap(({ file, css = [] }) => [file, ...css])
      .filter((file) => typeof file === "string" && /^assets\/[^?]+\.(js|css)$/.test(file));
    await Promise.all([...new Set(files)].map((file) => fetch(`/${file}`, { cache: "reload" }).catch(() => {})));
  }
  // A broken connection must not leave the retry button waiting indefinitely.
  void Promise.race([refreshAssets().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 5000))])
    .finally(() => window.location.reload());
});

// Keep this entry independent of app imports: their parse/evaluation failures must
// leave a usable HTML screen, including when an old browser cannot load a chunk.
void import("./main").catch((error: unknown) => {
  const title = document.getElementById("startup-title");
  const description = document.getElementById("startup-description");
  if (title) title.textContent = "画面を読み込めませんでした";
  if (description) description.textContent = "通信状態を確認して、再読み込みをお試しください。";
  console.error("Kalori startup failed", error);
});
